// API 기본 URL 설정
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const port = typeof window !== 'undefined' ? window.location.port : '';
let apiBaseUrl;

if (hostname === 'localhost' || hostname === '127.0.0.1') {
  // 로컬 개발 환경에서는 프론트엔드 포트에 따라 백엔드 포트를 결정
  if (port === '8001') {
    // 개발 환경: 프론트엔드 8001 -> 백엔드 8011
    apiBaseUrl = 'http://localhost:8011';
  } else {
    // 운영 환경(로컬 테스트): 프론트엔드 8000 -> 백엔드 8010
    apiBaseUrl = 'http://localhost:8010';
  }
} else if (hostname === 'visionwide.tail249e88.ts.net') {
  // Tailscale 로컬 접속: 프론트엔드 8001 -> 백엔드 8011
  apiBaseUrl = 'http://visionwide.tail249e88.ts.net:8011';
} else if (hostname === 'dev.widework.kr') {
  // 개발 서버 환경
  apiBaseUrl = 'https://dev.widework.kr';
} else {
  // 프로덕션 환경
  apiBaseUrl = 'https://widework.kr';
}

export const API_BASE_URL = apiBaseUrl;

// 이메일 전송 관련 설정
export const EMAIL_CONFIG = {
  // 기존 Gmail 설정 (주석 처리)
  // sender_email: "e.visionwide@gmail.com",
  // sender_password: "nqpv ouxp lknw qcns", //app password
  // default_receiver: "e.visionwide@gmail. 6com"
  
  // 기존 POP3/SMTP 설정 (mailplug) - 주석 처리
  // sender_email: "recruit@visionwide.kr",
  // smtp_host: "smtp.mailplug.co.kr",
  // smtp_port: 465,
  // smtp_secure: true, // SSL 연결
  // pop3_host: "pop3.mailplug.co.kr",
  // pop3_port: 995,
  // pop3_secure: true, // SSL 연결
  // username: "recruit",
  // password: "visionwide607@",
  // default_receiver: "admin@visionwide.kr"
  
  // 새로운 Gmail SMTP 설정
  sender_email: "e.visionwide@gmail.com",
  smtp_host: "smtp.gmail.com",
  smtp_port: 587,
  smtp_secure: false, // STARTTLS 사용
  username: "e.visionwide@gmail.com",
  password: "ksqb pewn eors zmcs",
  default_receiver: "admin@visionwide.kr"
};

// 기타 환경 설정
let isProd = false;
if (typeof window !== 'undefined') {
  const currentHostname = window.location.hostname;
  const currentPort = window.location.port;

  // 실제 운영 도메인이거나, localhost의 운영 테스트 포트(8000)일 경우 Production으로 간주
  if (currentHostname === 'recruit.visionwide.kr' || currentHostname === 'widework.kr' || (currentHostname === 'localhost' && currentPort === '8000')) {
    isProd = true;
  }
}
export const IS_PRODUCTION = isProd;

// 기타 구성값
export const SITE_TITLE = 'WIDE-WORK';
export const COMPANY_NAME = '비전와이드';
export const COMPANY_EMAIL = 'admin@visionwide.kr';
export const COMPANY_ADDRESS = '경기도 광명시 오리로854번길 12, 3층 304호(철산동, 세인트빌딩)';
export const COMPANY_PHONE = '02-565-5747';

// 슈퍼 관리자 이메일 목록
export const SUPER_ADMIN_EMAILS = [
  'admin@visionwide.kr',
  'master@visionwide.kr',
  'smi@visionwide.kr',
  'pnj-007@outlook.kr'
];

/**
 * 주어진 이메일이 슈퍼 관리자인지 확인
 * @param {string} email - 확인할 이메일 주소
 * @returns {boolean} 슈퍼 관리자 여부
 */
export function isSuperAdmin(email) {
  if (!email) return false;
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase().trim());
}

/**
 * 사용자가 관리자(role='admin' 또는 슈퍼 관리자)인지 확인
 * @param {Object} user - 사용자 객체 (role과 email 속성 필요)
 * @returns {boolean} 관리자 여부
 */
export function isAdminUser(user) {
  if (!user) return false;
  return user.role === 'admin' || isSuperAdmin(user.email);
} 